// import React, { useState } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import Modal from '../Modal/Modal';
// import GeneratedScenarioBox from '../scenarioCards/generatedScenarioBox/GeneratedScenarioBox';

// const GeneratedTestCases = () => {
//   const { generatedTestCases } = useSelector((state) => state.testCases);
//   const dispatch = useDispatch();
//   const [isModalOpen, setModalOpen] = useState(false);
//   const [selectedTestCase, setSelectedTestCase] = useState(null);

//   const openModal = (testCase) => {
//     setSelectedTestCase(testCase);
//     setModalOpen(true);
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//   };

//   return (
//     <section className="w-full min-h-96 mx-auto bg-gray-100 p-6 rounded-lg shadow-md">
//       <h3 className="text-2xl font-semibold text-gray-800 mb-4">
//         Generated Test Scenarios
//         <span className="text-xl text-gray-500 pl-2">({generatedTestCases.length})</span>
//       </h3>
//       <div className="max-h-screen overflow-y-auto space-y-6">
//         {generatedTestCases.length > 0 ? (
//           generatedTestCases.map((testCase) => (
//             <GeneratedScenarioBox
//               key={testCase.id}
//               testCase={testCase}
//               openModal={openModal}
//               dispatch={dispatch}
//             />
//           ))
//         ) : (
//           <div className="flex items-center justify-center h-64 bg-gray-100">
//             <p className="text-center text-gray-600">Please generate testcases.</p>
//           </div>
//         )}
//       </div>
//       <Modal isOpen={isModalOpen} onClose={closeModal} testCase={selectedTestCase} />
//     </section>
//   );
// };

// export default GeneratedTestCases;


import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
  Box, 
  Typography, 
  IconButton, 
  Tooltip, 
  Chip, 
  Link 
} from '@mui/material';
import { 
  DataGrid, 
} from '@mui/x-data-grid';
import {
  CheckIcon,
  XMarkIcon,
 } from '@heroicons/react/24/outline';
 import { 
  Topic,
  Done,
  Close,
 } from '@mui/icons-material';
 import { approveTestCase, discardTestCase } from '../../features/testCases/testCasesSlice';
 // components
 import ExpandableCell from '../datagrid/ExpandableCell/ExpandableCell';
 import DataGridContainer from '../datagrid/dataGridContainer/DataGridContainer';
import TableComponent from '../TableComponent';
import { useSnackbar } from '../../utils/useSnackbar';
import ConfirmationModal from '../Modal/ConfirmationModal';

const GeneratedTestCases = () => {
  const dispatch = useDispatch();
  const { generatedTestCases } = useSelector((state) => state.testCases);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState(generatedTestCases);
  const [discardModalOpen, setDiscardModalOpen] = useState(false);
  const { showSnackbar } = useSnackbar();
  
  // Handle bulk approval using existing reducer
  const handleBulkApprove = () => {
    let approvedCount = 0;
    selectedRows.forEach(id => {
      const testCase = generatedTestCases.find(tc => tc.id === id);
      if (testCase) {
        dispatch(approveTestCase(testCase));
        approvedCount++;
        setRowData((prevRowData) => prevRowData.filter((row) => row.id !== testCase.id));
        setSelectedRows([]);
      }
    });
    showSnackbar(`${approvedCount} test cases approved successfully`, "success");
  };

  // Handle bulk discard using existing reducer
  const handleBulkDiscard = () => {
    let discardedCount = 0;
    selectedRows.forEach(id => {
      const testCase = generatedTestCases.find(tc => tc.id === id);
      if (testCase) {
        dispatch(discardTestCase(testCase));
        discardedCount++;
        setRowData((prevRowData) => prevRowData.filter((row) => row.id !== testCase.id));
        setSelectedRows([]);
      }
    });
    setDiscardModalOpen(false);
    showSnackbar(`${discardedCount} test cases discarded successfully`, "success");
  };

  // const handleApproveIndividual = (testCase) => {
  //   dispatch(approveTestCase(testCase));
    
  //   // Delay the state update to avoid DataGrid issues
  //   setTimeout(() => {
  //     setRowData((prevRowData) => prevRowData.filter((row) => row.id !== testCase.id));
  //   }, 0);
  // };

  // const handleDiscardIndividual = (testCase) => {
  //   dispatch(discardTestCase(testCase));
    
  //   // Delay the state update to avoid DataGrid issues
  //   setTimeout(() => {
  //     setRowData((prevRowData) => prevRowData.filter((row) => row.id !== testCase.id));
  //   }, 0);
  // };
  
  // // Fixed action buttons for the data grid rows
  // const rowActionButtons = [
  //   {
  //     name: 'Approve',
  //     tooltip: 'Approve',
  //     color: 'text-green-600',
  //     hoverColor: 'hover:text-green-700',
  //     icon: <DoneIcon fontSize="small" />,
  //     action: (testCase) => handleApproveIndividual(testCase),
  //   },
  //   {
  //     name: 'Discard',
  //     tooltip: 'Discard',
  //     color: 'text-red-600',
  //     hoverColor: 'hover:text-red-700',
  //     icon: <CloseIcon fontSize="small" />,
  //     action: (testCase) => handleDiscardIndividual(testCase),
  //   },
  // ];

  // Header action buttons
  const headerActionButtons = [
    {
      name: 'Approve Selected',
      tooltip: 'Approve Selected Test Cases',
      icon: <CheckIcon style={{ width: 18, height: 18 }} />,
      action: handleBulkApprove,
      disabled: selectedRows.length === 0
    },
    {
      name: 'Discard Selected',
      tooltip: 'Discard Selected Test Cases',
      icon: <XMarkIcon style={{ width: 18, height: 18 }} />,
      action: () => setDiscardModalOpen(true),
      disabled: selectedRows.length === 0
    }
  ];

  // Define columns specific to generated test cases
  const columns = [
    {
      field: '__check__',
      hideable: false,
      sortable: false,
      filterable: false,
      minWidth: 55,
      maxWidth: 55,
      resizable: false,
      headerAlign: 'center',
      align: 'center',
      resizable: false,   
    },
    { 
      field: 'type', 
      headerName: 'Type', 
      width: 200,
      renderCell: (params) => (
       <div
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
       >
          {params.value}
       </div>
      )
    },
    { 
      field: 'title', 
      headerName: 'Title', 
      width: 250 
    },
    { 
      field: 'description', 
      headerName: 'Description', 
      flex: 1, 
      minWidth: 300,
      renderCell: (params) => (
        <ExpandableCell value={params.value} />
      )
    },
    // {
    //   field: 'actions',
    //   headerName: 'Actions',
    //   width: 150,
    //   sortable: false,
    //   align: 'center',
    //   headerAlign: 'center',
    //   renderCell: (params) => {
    //     return (
    //       <Box 
    //         className="flex space-x-2" 
    //         sx={{ 
    //           width: '100%', 
    //           display: 'flex', 
    //           justifyContent: 'center' 
    //         }}
    //       >
    //         {rowActionButtons.map((button, index) => (
    //           <Tooltip key={index} title={button.tooltip}>
    //             <IconButton
    //               className={`${button.color} ${button.hoverColor}`}
    //               onClick={(e) => {
    //                 e.stopPropagation(); // Stop the event from propagating
    //                 button.action(params.row); // Then call the button action
    //               }}
    //               size="small"
    //             >
    //               {button.icon}
    //             </IconButton>
    //           </Tooltip>
    //         ))}
    //       </Box>
    //     );
    //   },
    // },
  ];

  const headerContent = () => {
    return (
      <div>
        <Chip
          label={`Count: ${generatedTestCases.length}`}
          size="small"
          variant="filled"
          color="primary"
          sx={{
            borderRadius: 1,
            fontWeight: 'bold',
            backgroundColor: '#e0e0e0',
            color: '#424242',
          }}
        />
      </div>
    );
  };

  return (
    <>
      <Box sx={{ mb: 4 }}>  
        <TableComponent
          title="Generated Test Scenarios for Review"
          headerActionButtons={headerActionButtons}
          headerContent={headerContent}
          rows={rowData}
          columns={columns}
          viewType="genrateAITestCase"
          isCheckbox={true}
          isRowSelection={true}
          handleRowSelection={(selectionModel) => setSelectedRows(selectionModel)}
          selectedRows={selectedRows}
          disableSelectionOnClick={true}
          getRowHeight={() => 'auto'}
          getEstimatedRowHeight={() => 100}
          isRowSelectable={(row) => { return rowData.map(item => item.id).includes(row.id); }}
          tableHeight={'90vh'}
          customStyles={{
            '& .MuiDataGrid-cell': {
              padding: 1,
              display: 'flex',
              alignItems: 'center',
            },
          }}
          isData={generatedTestCases && generatedTestCases.length > 0}
          customNoData={ 
            <Box 
              sx={{ 
                height: 200, 
                display: 'flex', 
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center',
                bgcolor: '#f9f9f9',
                mx: 2,
                my: 4,
              }}
            >
              <Topic sx={{ fontSize: 48, color: '#9e9e9e', mb: 2 }} />
              <Typography variant="body1" color="textSecondary">
                No generated scenarios are available.
              </Typography>
            </Box>
          }
          disablePagination={true}
          disableFooter={true}
          hideColumns={['title']}
        />
      {/* <DataGridContainer
        name="Generated Test Scenarios for Review"
        headerContent={headerContent}
        headerActionButtons={headerActionButtons}
      >
        {generatedTestCases && generatedTestCases.length > 0 ? (
          <Box sx={{ height: 650, width: '100%' }}>
            <DataGrid
              rows={rowData}
              getRowId={(row) => {
                return row.id;
              }}
              isRowSelectable={(row) => {
                return rowData.map(item => item.id).includes(row.id);
            }}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5, 10, 20]}
              checkboxSelection
              onRowSelectionModelChange={(newSelectionModel) => {
                setSelectedRows(newSelectionModel);
              }}
              rowSelectionModel={selectedRows}
              disableSelectionOnClick
              disableRowSelectionOnClick
              getRowHeight={() => 'auto'}
              getEstimatedRowHeight={() => 100}
              sx={{
                '& .MuiDataGrid-cell': {
                  padding: 1,
                  display: 'flex',
                  alignItems: 'center',
                },
              }}
            />
          </Box>
        ) : (
          <Box 
            sx={{ 
              height: 200, 
              display: 'flex', 
              flexDirection: 'column',
              justifyContent: 'center', 
              alignItems: 'center',
              bgcolor: '#f9f9f9',
              mx: 2,
              my: 4,
            }}
          >
            <Topic sx={{ fontSize: 48, color: '#9e9e9e', mb: 2 }} />
            <Typography variant="body1" color="textSecondary">
              No generated scenarios are available.
            </Typography>
          </Box>
        )}
      </DataGridContainer> */}
      </Box>
      <ConfirmationModal
        open={discardModalOpen}
        onClose={() => setDiscardModalOpen(false)}
        onConfirm={handleBulkDiscard}
        title="Confirm Discard Action"
        message="You are about to discard the selected test cases. This action is irreversible. Do you wish to proceed?"
      />
   </>
  );
};

export default GeneratedTestCases;